module.exports = __webpack_public_path__ + "img/platform@3x.dc79ee44.png";